import { useState } from 'react';
import OEIDropdown from './OEIDropdown';
import OEIToggle from './OEIToggle';
import OEIInput from './OEIInput';
import ConfirmationModel from './ConfirmationModel';
import Dropdown from './DropDown';

import {
  CHECKED, CLIENT_NAME, DISABLED, EMPTY,
  EVENT_TYPE1, EVENT_TYPE2, EVENT_TYPE3, EVENT_TYPE4, EVENT_TYPE5,
  EVENT_TYPE6, EVENT_TYPE7, EVENT_TYPE8, EVENT_TYPE9, EVENT_TYPE10,
  EVENT_TYPE11, EVENT_TYPE12, EVENT_TYPE13,
  SYSTEM_NAME2, SYSTEM_NAME4, SYSTEM_NAME5, UNCHECKED
} from './Constants';

const EVENT_TYPES = [
  EVENT_TYPE1, EVENT_TYPE2, EVENT_TYPE3, EVENT_TYPE4, EVENT_TYPE5,
  EVENT_TYPE6, EVENT_TYPE7, EVENT_TYPE8, EVENT_TYPE9, EVENT_TYPE10,
  EVENT_TYPE11, EVENT_TYPE12, EVENT_TYPE13
];

const ACCESS_OPTIONS = [
  { value: 'All', label: 'All Child Accounts' },
  { value: 'No', label: 'No Child Accounts' },
  { value: 'Single', label: 'Specific Child Accounts' }
];

export default function NewAccountMappingPopover({
  type, errors, newData, setNewData, setErrors, setChecked, setCheckedList, checked,
  middlePopoverName, setMiddlePopoverName, removeMainItem
}) {
  const [deleteConf, openDeleteConf] = useState(false);
  const [deleteItem, setDeleteItem] = useState({});
  const [checkItem, setcheckedItem] = useState(newData.parentAccessEnable?newData.parentAccessEnable=== "Enabled" : true);
  const [subAccountValue, setSubAccountValue] = useState('');
  const [subAccountCount, setSubAccountCount] = useState(0);
  const [showDialog, setShowDialog] = useState(false);

  const updateData = (key, value) => {
    setNewData(prev => ({ ...prev, [key]: value }));
    setErrors({ ...errors, error1: EMPTY, error2: EMPTY, error7: EMPTY });
  };

  const setSystemMapping = e => updateData('systemName', e.target.value);
  const setSystemIntgId = val => updateData('systemIntgId', val);
  const setParentAccessEnable = val => updateData('parentAccessEnable', val);
  const setChildAccessEnable = val => updateData('childAccessEnable', val);
  const clearErrors = () => setErrors({ ...errors, error1: EMPTY, error2: EMPTY, error7: EMPTY, error9: EMPTY });


  const setSubAccountId = (index, value) => {
    setNewData(prev => {
      const subAccountIds = [...(prev.subAccountIds || [])];
      if (index >= subAccountIds.length) {
        subAccountIds.push(value);
      } else {
        subAccountIds[index] = value;
      }
      return {
        ...prev,
        subAccountIds
      };
    });
    setSubAccountValue('');
    setErrors({ ...errors, error1: EMPTY, error2: EMPTY, error7: EMPTY });
  };

  const removeSubAccountId = (idToRemove) => {
    setNewData(prev => ({
      ...prev,
      subAccountIds: (prev.subAccountIds || []).filter(id => id !== idToRemove)
    }));
  };

  const getAllCheckedList = data => data.reduce((acc, item) => acc.concat(item.checkedList), []);
  const setStatus = (totalList, list, key) =>
    list.includes(key) ? CHECKED : totalList.includes(key) ? DISABLED : UNCHECKED;
  const generateCheckedList = (list, totalList) =>
    EVENT_TYPES.map(key => ({ key, value: setStatus(totalList, list, key) }));

  const uploadNewFile = () => {
    const totalList = getAllCheckedList(newData.passportData);
    setMiddlePopoverName("New Passport Template");
    setChecked([]);
    setErrors({ ...errors, error3: EMPTY, error8: EMPTY, error5: EMPTY });
    setNewData({
      ...newData,
      fileName: EMPTY,
      pptConfiguration: EMPTY,
      PassportTemplateMappingName: EMPTY,
      checkedList: []
    });
    setCheckedList(generateCheckedList([], totalList));
  };

  const handleEdit = item => {
    const totalList = getAllCheckedList(newData.passportData);
    const list = [...item.checkedList];

    setNewData({
      ...newData,
      PassportTemplateMappingName: item.PassportTemplateMappingName,
      checkedList: list,
      editItem: item,
      pptConfiguration: item.pptConfiguration,
      fileName: item.fileName
    });

    setCheckedList(generateCheckedList(list, totalList));
    setMiddlePopoverName('Edit Passport Mapping');
  };

  const renderSystemMappingInput = () =>
    type === 'edit' ? (
      <OEIInput
        readOnly
        name="Account Name"
        value={newData.systemName}
        errorMessage={errors.error1}
        setSelectedValue={setSystemMapping}
      />
    ) : (
      <OEIDropdown
        name="Account Name"
        setMessage={clearErrors}
        errorMessage={errors.error1}
        selected="true"
        setSelectedValue={setSystemMapping}
      />
    );
  const validateSubAccount = (value, existingIds,systemIntgId) => {
    if (value.trim() === '') return "Child Account Number is required";
    if (!/^\d+$/.test(value)) return "Child Account must be a number";
    if (existingIds.includes(value)) return "Child Account Number already exists";
    if(systemIntgId && value === systemIntgId) return "Child Account Number cannot be same as Parent Account Number";
    return null;
  };

  const handleAddChildAccount = () => {
    const errorMsg = validateSubAccount(subAccountValue, newData.subAccountIds || [], newData.systemIntgId);
    if (errorMsg) {
      setErrors({ ...errors, error7: errorMsg });
      return;
    }
    setSubAccountCount(newData.subAccountIds ? newData.subAccountIds.length : 0);
    const subAccountCount = newData.subAccountIds ? newData.subAccountIds.length : 0;
    setSubAccountId(subAccountCount, subAccountValue);
    setShowDialog(false);
  };

  const renderToggleSection = () => {
    const isEdit = type === 'edit';
    const showMappingToggle = [SYSTEM_NAME4, SYSTEM_NAME5].includes(newData.systemName);
    const showPassportSection = checked || isEdit;

    if (!showMappingToggle) return null;

    return (
      <div>
        <OEIToggle
          checked={isEdit ? true : checked}
          onChange={newChecked => {
            setChecked(newChecked);
            setErrors({ ...errors, error2: EMPTY });
            updateData('systemIntgId', newChecked ? "Enabled" : "Disabled");
          }}
          disabled={isEdit}
          label={`${newData.systemName} mapping ${isEdit || checked ? 'Enabled' : 'Disabled'}`}
          errorMessage={errors.error2}
        />

        {isEdit && (
          <span className="line-message">
            <p style={{ margin: 0 }}>To disable system mapping please delete mapping</p>
          </span>
        )}

        {showPassportSection && newData.systemName === SYSTEM_NAME4 && (
          <div className="oe-form-field">
            <label className="attendee-list__label event_form__items-section__title" style={{ color: '#1A1A1A', paddingLeft: 0, display: 'flex' }}>
              Passport templates Event Types
            </label>

            {newData.passportData.map(item => (
              <div className="email_row" key={item.PassportTemplateMappingName}>
                <div className="m overflow-ellipsis" style={{ width: '120px' }}>{item.PassportTemplateMappingName}</div>
                <div className="m overflow-ellipsis">{item.checkedList.length > 0 ? item.checkedList.length : ''}</div>
                <button onClick={() => handleEdit(item)} className="default-button default-button--slim-edit default-button--link visible-while-hovered">
                  <span>Edit</span>
                </button>
                <button
                  onClick={() => {
                    openDeleteConf(true);
                    setDeleteItem(item);
                  }}
                  type="button"
                  className="default-button default-button--slim-edit default-button--link visible-while-hovered email-remove-label"
                  style={{ color: "#ff0000" }}
                >
                  <span>{type === 'edit' ? 'Delete' : 'Remove'}</span>
                </button>
              </div>
            ))}

            <div className="m">
              <button
                type="button"
                className="email-new"
                onClick={uploadNewFile}
                style={{
                  cursor: 'pointer',
                  backgroundColor: middlePopoverName === 'New Passport Template' ? '#C4F8E4' : 'white',
                  color: middlePopoverName === 'New Passport Template' ? '#1A1A1A' : '#00787A'
                }}
              >
                <span>+ New Passport Template</span>
              </button>
            </div>
            <div className="oe-form-field__error">{errors.error6}</div>
          </div>
        )}
      </div>
    );
  };

  const renderOtherSystemOptions = () => {
    if (newData.systemName === SYSTEM_NAME2) {
      return (
        <>
          <OEIInput
            errorMessage={errors.error2}
            value={newData.systemIntgId}
            setValue={setSystemIntgId}
            label="Parent Account Number"
            showError="false"
          />
          <OEIToggle
            checked={checkItem}
            onChange={newChecked => {
              setcheckedItem(newChecked);
              setErrors({ ...errors, error2: EMPTY });
              setParentAccessEnable(newChecked ? "Enabled" : "Disabled");
            }}
            label={`Parent Account Access ${checkItem ? 'Enabled' : 'Disabled'}`}
            errorMessage={errors.error3}
          />
          <Dropdown
            name="Child Account Access"
            selectedValue={newData.childAccessEnable}
            setSelectedValue={setChildAccessEnable}
            errorMessage={errors.error3}
            options={ACCESS_OPTIONS}
          />
          {newData.childAccessEnable === "Single" && (
            <>
              <label style={{ color: '#1A1A1A', paddingLeft: '0px', display: 'flex' }} class="attendee-list__label event_form__items-section__title">Child Accounts
              </label>
              {newData.subAccountIds && newData.subAccountIds.map((subAccountId) => (
                subAccountId &&
                <div class="email_row">
                  <div title={subAccountId} style={{ width: '205px' }} class="overflow-ellipsis">{subAccountId}</div>
                  <button onClick={e => removeSubAccountId(subAccountId)} type='button' style={{ color: "#ff0000" }} class="default-button default-button--slim-edit default-button--link visible-while-hovered email-remove-label"><span>Remove</span></button>
                </div>
              ))}
              <button
                type="button"
                onClick={() => {
                  setSubAccountCount(prev => prev + 1);
                  setShowDialog(true);
                  clearErrors();
                }}
                className="email-new"
              >
                <span style={{ cursor: 'pointer' }}>+ Add Child Account</span>
              </button>
            </>
          )}
          {
            (errors.error9 !== EMPTY && errors.error9 !== undefined) ?
              <div className="oe-form-field__error">{errors.error9}</div>
              : EMPTY
          }
        </>
      );
    } else {
      return (
        <OEIInput
          errorMessage={errors.error2}
          value={newData.systemIntgId}
          setValue={setSystemIntgId}
          name={CLIENT_NAME}
          label="System Mapping"
          showError="false"
        />
      );
    }
  };

  return (
    <>
      {renderSystemMappingInput()}
      {renderToggleSection() || renderOtherSystemOptions()}

      {showDialog && (
        <div className={'sub-windows-host8'}>
          <div className="oe-popup-layout oe-popup-layout--popover position--fix">
            <div className="oe-popup-layout__body" style={{ padding: '0px 5px' }}>
              <OEIInput
                value={subAccountValue}
                setValue={(val) => { setSubAccountValue(val); setErrors({ ...errors, error7: EMPTY }) }}
                label="Child Account"
                type="text"
                errorMessage={errors.error7}
                showError="true"
              />
            </div>
            <div className="oe-popup-layout__footer">
              <div className="buttons-block buttons-block--from-right">
                <button
                  type="button"
                  onClick={handleAddChildAccount}
                  className="default-button default-button--fat default-button--confirm-safe"
                >
                  <span>Add</span>
                </button>
                <button
                  type="button"
                  onClick={() => setShowDialog(false)}
                  className="default-button default-button--cancel default-button--fat"
                >
                  <span>Cancel</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {deleteConf && (
        <ConfirmationModel
          deleteFunction={() => {
            removeMainItem(deleteItem);
            openDeleteConf(false);
          }}
          open={deleteConf}
          name="passport template"
          setOpen={openDeleteConf}
        />
      )}
    </>
  );
}
